import ReactDOM from "react-dom/client";
import "normalize.css";
import { initial } from "@/utils/initial";
import App from "./index.tsx";
import "intersection-observer";

initial({ appName: "par-marketing" });

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
